import React,{useEffect,useState,useRef} from 'react'
import {  useSelector} from "react-redux";
import { useParams ,Link} from "react-router-dom";
import moment from 'moment';
import { Drawer,Form,Button,Row, Col,Divider,Typography ,DatePicker,Select,Input } from 'antd';
import { DownloadOutlined,PlusCircleFilled,EditFilled ,DeleteFilled} from '@ant-design/icons';

import useAxios from './../../CustomHooks/useAxios';

import ShowTelsTable from './ShowTelsTable';
import PageLink from './../PageLink/PageLink';
import AddTels from "./AddTels";

const { Text } = Typography;
const { Option } = Select;
const dateFormat = 'YYYY-MM-DD';
export default function Tels() {
    let { page } = useParams();
    const {axiosi}=useAxios();
    const user = useSelector((state) => state.loginReducer.user);
    // console.log("[Tels]:user=",user);
    const [visibleAdd, setVisibleAdd] = useState(false);
    const [data,setData]=useState();
    const [refreshSearch,setRefreshSearch]=useState(true);

    const [company_name,setCompany_name]=useState('');
    const [contactname,setContactname]=useState('');
    const [telin,setTelin]=useState('');
    const [telout,setTelout]=useState('');


    const [hideItem,setHideItem]=useState('');
    const handleAdd=()=>{
        console.log("[handleAdd]:");
        setVisibleAdd(true);
    }
    const onCloseAdd=()=>{
        setVisibleAdd(false);
        
    }
    useEffect(()=>{
        if (user?.agents) {
        if(user?.agents[0].company_id!==1) {
            // console.log("[Tels-useEffect]-------------------:Set hideItem");
            setHideItem('hideItem');
            // setHideItem('col');
        } else {
            // console.log("[Tels-useEffect]-------------------:Set col");
            setHideItem('col');
        }
        // console.log("[Tels-useEffect]-------------------:company_id=",user?.agents[0]?.company_id);
    }
    },[user?.agents])
    useEffect(()=>{
        doSearch();
    },[refreshSearch,page]);

    // const [name,setName]=useState('');

    const handleSearch= ()=>{
        console.log("[handleSearch]");
        // setName(val);
        setRefreshSearch(pre=>!pre)
    }

    const doSearch= async()=>{
        console.log("[search]");
        const kq=await axiosi.get('tels',{params:{page,pageSize:20,telin,telout,company_name,contactname}});
        console.log("[handleSearch]:kq.data=",kq.data);
        setData(kq.data);
    }
  return (<>
  
        <Drawer title="Add  Menu Item" placement="right" onClose={onCloseAdd} visible={visibleAdd}>             
                    <AddTels setVisibleAdd={setVisibleAdd} setRefreshSearch={setRefreshSearch}  />        
        </Drawer>
        <section className='search'>
        <div className="container">
            <div className="row">
                <Typography.Title  level={3}>Search :
                <Button onClick={handleAdd}  className="addButton" icon={<PlusCircleFilled  style={{ color: '#1890ff' }} />}>Add</Button>
                </Typography.Title>
                
            </div>
            
            <div className="row">
            {/* <Input.Group compact>      
                <Input.Search addonBefore="ITSP Name: " enterButton 
                 onSearch={handleSearch} allowClear 
                 style={{ width: '70%' }} defaultValue="" />
            </Input.Group> */}
                <div className="col">
                    <label>Telin :</label>
                    <Input  onChange={({ target: { value } } )=>setTelin(value)}/>
                </div>
                <div className="col">
                    <label>Telout :</label>
                    <Input  onChange={({ target: { value } } )=>setTelout(value)}/>
                </div>
                <div className={hideItem}>
                    <label>Company Name :</label>
                    <Input  onChange={({ target: { value } } )=>setCompany_name(value)}/>
                </div>
                <div className={hideItem}>
                    <label>Contact Name :</label>
                    <Input  onChange={({ target: { value } } )=>setContactname(value)}/>
                </div>
                <div className={"col"}>
                    <label>Search:</label>
                    <Button onClick={handleSearch}>Search :</Button>
                </div>
                
            </div>
        </div>

    </section>
    <section className='searchResult'>
        <div className="row">
        <Typography.Title  level={3}>Result</Typography.Title>
        </div>
        <div className="row">
            {data?.rows && <ShowTelsTable data={data.rows} setRefreshSearch={setRefreshSearch} />}
        </div>
        <div className="row">
        {data?.pages>1?<PageLink pageSize={data.pageSize} searchpage={"tels"} pages={data.pages} numrows={data.numrows} page={data.page} />:<h1>chi co' 1 page</h1>}
        </div>
        

    </section>
  </>);
}
